import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ComponentWrapper } from '@trello/component-wrapper';
import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import styles from './LazyWorkspaceJoinRequestList.less';

interface WorkspaceRequestListComponentProps {
  orgId: string;
  orgType: 'bc' | 'enterprise' | 'free' | 'standard';
  memberTypeFilter: 'guest' | 'request' | 'team-member';
  filter?: string;
  orgMemberLimit?: number;
  orgIdEnterprise?: string;
  orgEnterpriseName?: string;
}

export const LazyWorkspaceJoinRequestList: FunctionComponent<
  WorkspaceRequestListComponentProps
> = ({ memberTypeFilter, ...props }) => {
  const WorkspaceJoinRequestList = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "join-request-list" */ 'app/src/components/WorkspaceJoinRequestList'
      ),
    {
      namedImport: 'WorkspaceJoinRequestList',
    },
  );

  if (memberTypeFilter !== 'request') {
    return null;
  }

  return (
    <ComponentWrapper>
      <div className={styles.joinRequestSection}>
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <WorkspaceJoinRequestList {...props} />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </div>
    </ComponentWrapper>
  );
};
